const sessionStorageTargetKeys = ["HR_CHAT_BOT_CONVERSATION_CONTEXT_SESSION"];
const localStorageTargetKeys = ["WORKFLOW_LAST_SEEN_VIEW_ID"];
const invalidateSessionStorage = () => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    for (const sessionStorageTargetKey in sessionStorageTargetKeys) {
      Object.keys(window.sessionStorage).filter((key) => key.includes(sessionStorageTargetKey)).forEach((key) => window.sessionStorage.removeItem(key));
    }
  } catch {
  }
};
const invalidateLocalStorage = () => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    for (const localStorageTargetKey in localStorageTargetKeys) {
      Object.keys(window.localStorage).filter((key) => key.includes(localStorageTargetKey)).forEach((key) => window.localStorage.removeItem(key));
    }
  } catch {
  }
};

export { invalidateLocalStorage, invalidateSessionStorage };
//# sourceMappingURL=clearBrowserStorage.mjs.map
